<template>
  <a v-on:click="$router.go(-1)" class="fl back-btn"></a>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// BackBtn.vue?0e30f564